export default function Menu(els) {
  const menu = document.querySelector(".signup-btn");

  els.forEach((el) =>
    el.addEventListener("click", () => {
      menu.classList.add("hidden");
    })
  );
}
